import { defineStore } from 'pinia'
import axios, { AxiosResponse } from "axios";
import * as v from '@/models/vscoreModels'
import { authStore } from '../index';
import { useRouter } from 'vue-router'


export const axiosInstance = () => {
    const auth = authStore();
    const authHeader = `Bearer ${auth.user.id_token}`;
    const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_REALTIME_URL+'realtime/',
        headers: {
            common: {
                Authorization: authHeader
            }
        }
    });
    axiosInstance.interceptors.request.use((request) => {
        request.transformResponse = [data => data]
        return request
    });
    axiosInstance.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        return error
    });
    return axiosInstance;
}

export const axiosInstance2 = () => {
    const auth = authStore();
    const authHeader = `Bearer ${auth.user.id_token}`;
    const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_GAMEMANAGE_URL +'gamemanager/',
        headers: {
            common: {
                Authorization: authHeader
            }
        }
    });
    axiosInstance.interceptors.request.use((request) => {
        request.transformResponse = [data => data]
        return request
    });
    axiosInstance.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        return error
    });
    return axiosInstance;
}

export const handleError = (error: any) => {
    console.error(error);
    return Promise.reject(error);
}

export const querystate = defineStore('vScoreState', {
    state: () => ({
        currentPlayState: {
            delivery: <v.Delivery>{
                number: 0,
                ball: 0,
                over: 0,
                innings: 0,
                newBallTaken: false,
                runs: 0,
                boundaryRuns: 0,
                isValid: false,
                freeHit: false,
                noballs: 0,
                wides: 0,
                byes: 0,
                legbyes: 0,
                striker: <v.DeliveryBatsman>{
                    id: "",
                    name: ""
                },
                nonStriker: <v.DeliveryNonStriker>{
                    id: "",
                    name: ""
                },
                bowler: <v.DeliveryBowler>{
                    id: "",
                    name: ""
                },
                powerplay: false,
                bowlingEnd: v.BowlingEndEnum.NORTH,
                dismissal: [],
                breaks: []
            },
            shotIntention: 0,
            shotSelection: 0,
            extras: "Runs",
            shotSelectionText: "",
            bowlSelectionText: "",
            bowlingSelection: 0,
            battingSelection: [],
            fieldingSelection: [],
            penfor: 0,
            penagainst: 0,
            selectedBall: null,
            selectedBowler1: <any>null,
            selectedBowler1data: <any>[{}],
            selectedBowler2: <any>null,
            selectedBowler2data: <any>[{}],
            selectedBatt1: <any>null,
            selectedBatt1data: <any>null,
            selectedBatt2: <any>null,
            selectedBatt2data: <any>null,
            isSelectedBatt1: false,
            isSelectedBowl1: false,
            isblurred: true,
            inningsIndex: 0,
            reviews: <any>null,
            targetScore: 0,
            targetOvers: 0,
        },
        inningsData: [ // WHY CANT I USE V.INNINGS
            {
            }
        ],
        matchStatus: [ // WHY CANT I USE V.INNINGS
            {
            }
        ],
        battingTeam: <v.TeamSheet>{},
        bowlingTeam: <v.TeamSheet>{},
        MatchInfo: <v.Match>{
        },
        version: -1
    }),
    getters: {
        getCurrentPlayState(state) {
            return state.currentPlayState
        },
        getInningsData(state) {
            return state.inningsData
        },
        getBattingTeam(state) {
            return state.battingTeam
        },
        getBowlingTeam(state) {
            return state.bowlingTeam
        },
        getMatchInfo(state) {
            return state.MatchInfo
        },
        getMatchStatus(state) {
            return state.matchStatus
        },
    },
    actions: {
        // saveEditToBall(index: any, editIndex: any, replacement: any) {
        //     this.inningsData[index].previousDeliveries[editIndex] = replacement
        // },
        resetCurrentPlayState(resetState: any) {
            this.currentPlayState = resetState
        },
        setBattingTeam(newState: any) {
            this.battingTeam = newState
        },
        setBowlingTeam(newState: any) {
            this.bowlingTeam = newState
        },
        async retreveInningsDeliveries(matchId: string, inningsNumber: string) {
            try {
                const result = await axiosInstance().get(`/match/${matchId}/${inningsNumber}/deliveries`);
                // console.log(result)
                const resultparsed = JSON.parse(result.data)
                const deliveries: any[] = []
                resultparsed.forEach((element: { deliveries: any; }) => {
                    deliveries.push(element)
                });

                return deliveries
            } catch (error) {
                return handleError(error);
            }
        },
        async postTeam(params: any, headers: any) {
            try {
                return await axiosInstance().post(`/matchstatus/`, params, headers);
            } catch (error) {
                return handleError(error);
            }
        },
        async addInnings(matchId: string, number: number) {
            if (number == 0) {
                number = 1
            }
            try {
                const params = {
                    "number": number,
                    "battingTeam": {
                        "id": this.battingTeam.team.id,
                        "name": this.battingTeam.team.name
                    },
                    "bowlingTeam": {
                        "id": this.bowlingTeam.team.id,
                        "name": this.bowlingTeam.team.name
                    }
                }
                await axiosInstance().post(`/match/${matchId}/add-innings`, params, { headers: { 'If-Match': 'W/"' + (this.version) + '"' } });
                await this.getMatchById(matchId)
                this.currentPlayState.isblurred
                return
            } catch (error) {
                return handleError(error);
            }
        },
        async startPlay() {
            let bowler: any;
            let striker: any;
            let nonStriker: any;

            if (this.currentPlayState.isSelectedBatt1) {
                striker = this.currentPlayState.selectedBatt1
                nonStriker = this.currentPlayState.selectedBatt2
            } else {
                striker = this.currentPlayState.selectedBatt2
                nonStriker = this.currentPlayState.selectedBatt1
            }
            if (this.currentPlayState.isSelectedBowl1) {
                bowler = this.currentPlayState.selectedBowler1
            } else {
                bowler = this.currentPlayState.selectedBowler2
            }
            this.currentPlayState.delivery.striker = { id: striker?.player.id, name: striker?.player.name }
            this.currentPlayState.delivery.nonStriker = { id: nonStriker?.player.id, name: nonStriker?.player.name }
            this.currentPlayState.delivery.bowler = { id: bowler?.player.id, name: bowler?.player.name }

            const deliveryStartObject = {
                "innings": this.currentPlayState.delivery.innings,
                "over": this.currentPlayState.delivery.over,
                "number": this.currentPlayState.delivery.number,
                "ball": this.currentPlayState.delivery.ball,
                "powerplay": this.currentPlayState.delivery.powerplay,
                "bowlingEnd": this.currentPlayState.delivery.bowlingEnd,
                "striker": this.currentPlayState.delivery.striker,
                "nonStriker": this.currentPlayState.delivery.nonStriker,
                "newBallTaken": this.currentPlayState.delivery.newBallTaken,
                "bowler": this.currentPlayState.delivery.bowler,
            }
            try {

                await axiosInstance().post(`/match/${this.MatchInfo.id}/start-play`, deliveryStartObject, { headers: { 'If-Match': 'W/"' + (this.version) + '"' } }).then((response) => {
                    this.apiPostResponse(response)// undefined
                });
                return

            } catch (error) {
                return handleError(error);
            }
        },
        async addDelivery(params: any) {
            try {
                return await axiosInstance().post(`/match/${this.MatchInfo.id}/add-delivery`, params, { headers: { 'If-Match': 'W/"' + (this.version) + '"' } }).then((response) => {
                    this.apiPostResponse(response)// undefined
                    return response
                });
            } catch (error) {
                return handleError(error);
            }
        },
        /**
         * 
         * @param params {
  "teamId": "string",
  "teamName": "string",
  "reviewType": "DRS",
  "result": "PENDING",
  "innings": 1,
  "over": 0,
  "delivery": 1,
  "ball": 1
}
         * @returns 
         */
        async putReview(params: any, editMode: boolean) {
            try {
                await axiosInstance().put(`/match/${this.MatchInfo.id}/review`, params, { headers: { 'If-Match': 'W/"' + (this.version) + '"' } }).then((response) => {
                    this.apiPostResponse(response)// undefined
                });
                if (!editMode) {
                    this.getMatchById(this.MatchInfo.id)
                }

            } catch (error) {
                return handleError(error);
            }
        },
        async JustinTest() {
            try {
                return await axiosInstance2().get(`/matches`);
            } catch (error) {
                return handleError(error);
            }
        },
        async updateDelivery(params: any, editmode: boolean, editIndex?: number) {
            let bowler: any;
            let striker: any;
            let nonStriker: any;

            if (this.currentPlayState.isSelectedBatt1) {
                striker = this.currentPlayState.selectedBatt1
                nonStriker = this.currentPlayState.selectedBatt2
            } else {
                striker = this.currentPlayState.selectedBatt2
                nonStriker = this.currentPlayState.selectedBatt1
            }
            if (this.currentPlayState.isSelectedBowl1) {
                bowler = this.currentPlayState.selectedBowler1
            } else {
                bowler = this.currentPlayState.selectedBowler2
            }
            this.currentPlayState.delivery.striker = { id: striker?.player.id, name: striker?.player.name }
            this.currentPlayState.delivery.nonStriker = { id: nonStriker?.player.id, name: nonStriker?.player.name }
            this.currentPlayState.delivery.bowler = { id: bowler?.player.id, name: bowler?.player.name }

            // if edit mode is true
            // do a comparison between 
            if (editmode) {

                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const differenceObject: any = Object.keys(this.currentPlayState.delivery).reduce((diff, key) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    if (this.inningsData[this.currentPlayState.inningsIndex].previousDeliveries[editIndex][key] == this.currentPlayState.delivery[key]) return diff
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    if (typeof this.currentPlayState.delivery[key] == 'object' && this.inningsData[this.currentPlayState.inningsIndex].previousDeliveries[editIndex][key].id == this.currentPlayState.delivery[key].id) return diff
                    return {
                        ...diff,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        [key]: this.currentPlayState.delivery[key]
                    }
                }, {})
                console.log(differenceObject)
                differenceObject.breaks = this.currentPlayState.delivery.breaks
                differenceObject.dismissal = this.currentPlayState.delivery.dismissal
                differenceObject.innings = this.currentPlayState.delivery.innings
                differenceObject.over = this.currentPlayState.delivery.over
                differenceObject.number = this.currentPlayState.delivery.number
                differenceObject.ball = this.currentPlayState.delivery.ball
                // console.log(differenceObject)
                params = differenceObject
            }
            try {
                return await axiosInstance().patch(`/match/${this.MatchInfo.id}/update-delivery`, params, { headers: { 'If-Match': 'W/"' + (this.version) + '"' } }).then((response) => {
                    this.apiPostResponse(response)// undefined
                    return response
                });
            } catch (error) {
                return handleError(error);
            }
        },
        async updateDeliveryPlayers() {
            let bowler: any;
            let striker: any;
            let nonStriker: any;

            if (this.currentPlayState.isSelectedBatt1) {
                striker = this.currentPlayState.selectedBatt1
                nonStriker = this.currentPlayState.selectedBatt2
            } else {
                striker = this.currentPlayState.selectedBatt2
                nonStriker = this.currentPlayState.selectedBatt1
            }
            if (this.currentPlayState.isSelectedBowl1) {
                bowler = this.currentPlayState.selectedBowler1
            } else {
                bowler = this.currentPlayState.selectedBowler2
            }
            this.currentPlayState.delivery.striker = { id: striker?.player.id, name: striker?.player.name }
            this.currentPlayState.delivery.nonStriker = { id: nonStriker?.player.id, name: nonStriker?.player.name }
            this.currentPlayState.delivery.bowler = { id: bowler?.player.id, name: bowler?.player.name }

            const playerobject = {
                striker: this.currentPlayState.delivery.striker,
                nonStriker: this.currentPlayState.delivery.nonStriker,
                bowler: this.currentPlayState.delivery.bowler,
                bowlingEnd: this.currentPlayState.delivery.bowlingEnd,
                innings: this.currentPlayState.delivery.innings,
                over: this.currentPlayState.delivery.over,
                number: this.currentPlayState.delivery.number,
                ball: this.currentPlayState.delivery.ball
            }

            // we have the correct things now so we need to remove unneccessary
            try {
                return await axiosInstance().patch(`/match/${this.MatchInfo.id}/update-delivery`, playerobject, { headers: { 'If-Match': 'W/"' + (this.version) + '"' } }).then((response) => {
                    this.apiPostResponse(response)// undefined
                    return response
                });
            } catch (error) {
                return handleError(error);
            }
        },
        async apiPostResponse(response: any) {
            try {
                // console.log(response)
                this.version = response.headers.etag.replace(/\D+/gm, "");
            } catch (e) {
                // console.log(response.response.status)
                if (response.response && response.response.status == 412) {
                    // Retrieve the new header from status
                    // Push
                } // status 412 is a precondition failed requiring a get of the new header
                // console.log(e)
            }
        },
        async initialiseMatchStatus(matchId: string, params: any, headers: any) {
            try {
                return await axiosInstance().post(`/matchstatus`, params, headers).then((response) => {
                    this.apiPostResponse(response)// undefined
                });
            } catch (error) {
                return handleError(error);
            }
        },
        async getMatchById(matchId: string) {
            try {
                const result = await axiosInstance2().get(`/matches/${matchId}`);
                const parsedmatch = JSON.parse(result.data)
                // console.log(parsedmatch)
                const res = await this.retreveMatchStatus(parsedmatch.id).then((response) => response)
                // console.log(res)
                // console.log(res.data)
                // console.log(res.status)
                // FIND OUT HOW TO FIX THIS ERROR
                if (res.status >= 300) {
                    console.log("NO STATUS FOUND")
                    // console.log(res)
                    // this is where I have to then create a new match since it doesnt exist
                    // call initialisematchstatus with ifmatch-1
                    let hometeam;
                    let awayteam;
                    if (parsedmatch.team1.homeTeam) {
                        hometeam = {
                            "id": `${parsedmatch.team1.team.id}`,
                            "name": `${parsedmatch.team1.team.name}`
                        },
                            awayteam = {
                                "id": `${parsedmatch.team2.team.id}`,
                                "name": `${parsedmatch.team2.team.name}`
                            }
                    } else {
                        hometeam = {
                            "id": `${parsedmatch.team2.team.id}`,
                            "name": `${parsedmatch.team2.team.name}`
                        },
                            awayteam = {
                                "id": `${parsedmatch.team1.team.id}`,
                                "name": `${parsedmatch.team1.team.name}`
                            }
                    }
                    await this.initialiseMatchStatus(matchId, {
                        "matchId": parsedmatch.id,
                        "name": `${parsedmatch.team2.team.name} VS ${parsedmatch.team1.team.name} @ ${parsedmatch.venue.name}`,
                        "startDate": parsedmatch.startDate,
                        "homeTeam": hometeam,
                        "awayTeam": awayteam,
                        'matchType' : parsedmatch.matchType,
                        "status": {
                            "day": 0,
                            "session": 0,  ////// HOW DO WE ACTUALLY POPULATE THIS DATA
                            "state": "PRE_MATCH"
                        }
                    }, { headers: { 'If-Match': 'W/"' + (this.version) + '"' } })

                    const res = await this.retreveMatchStatus(parsedmatch.id).then((response) => response)
                    if (res.status >= 300) {
                        console.log("Unable to create this match")
                    } else {
                        console.log("Match create complete")
                        const matchStatus = await JSON.parse(res.data)
                        this.MatchInfo = parsedmatch
                        this.inningsData = matchStatus.innings

                        this.version = matchStatus.version
                        this.foundMatchSetup(matchStatus)
                    }
                } else {
                    console.log("found a match")
                    const matchStatus = await JSON.parse(res.data)
                    this.MatchInfo = parsedmatch
                    matchStatus.innings.forEach((inning: any, index: number) => {
                        matchStatus.innings[index].previousDeliveries = inning.previousDeliveries.filter((delivery: any) => delivery.isInitialized)
                    });
                    this.inningsData = matchStatus.innings
                    this.matchStatus = matchStatus.match
                    this.currentPlayState.reviews = matchStatus.match.reviews
                    this.currentPlayState.targetScore = matchStatus.match.targetScore
                    this.currentPlayState.targetOvers = matchStatus.match.targetOvers

                    this.version = matchStatus.version
                    this.foundMatchSetup(matchStatus)
                    // this is where we set the status event if it exists
                }
            } catch (error) {
                return (false)
                return handleError(error);
            }
        },

        setbattBowlData() {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (this.MatchInfo.team1.team.id == this.inningsData[this.inningsData.length - 1].bowlingTeam.id) {
                this.battingTeam = this.MatchInfo.team2
                this.bowlingTeam = this.MatchInfo.team1
            } else {
                this.battingTeam = this.MatchInfo.team1
                this.bowlingTeam = this.MatchInfo.team2
            }

            if (!this.currentPlayState.isSelectedBatt1) {
                this.currentPlayState.selectedBatt1 = this.battingTeam.players.find(u => u.player.id === this.currentPlayState.delivery.nonStriker.id)
                this.currentPlayState.selectedBatt2 = this.battingTeam.players.find(u => u.player.id === this.currentPlayState.delivery.striker.id)
            } else {
                this.currentPlayState.selectedBatt2 = this.battingTeam.players.find(u => u.player.id === this.currentPlayState.delivery.nonStriker.id)
                this.currentPlayState.selectedBatt1 = this.battingTeam.players.find(u => u.player.id === this.currentPlayState.delivery.striker.id)
            }

            if (!this.currentPlayState.isSelectedBowl1) {
                this.currentPlayState.selectedBowler2 = this.bowlingTeam.players.find(u => u.player.id === this.currentPlayState.delivery.bowler.id)
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.currentPlayState.selectedBowler2data = [this.inningsData[this.currentPlayState.inningsIndex].bowlingSummary.find((u: { player: { id: any; }; }) => u.player.id === this.currentPlayState.selectedBowler2.player.id)]
                this.currentPlayState.selectedBowler1data = [{}]
                Object.assign(this.currentPlayState.selectedBowler2data[0], { dismissalAmount: this.currentPlayState.selectedBowler2data[0].dismissals.length })
            } else {
                this.currentPlayState.selectedBowler1 = this.bowlingTeam.players.find(u => u.player.id === this.currentPlayState.delivery.bowler.id)
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.currentPlayState.selectedBowler1data = [this.inningsData[this.currentPlayState.inningsIndex].bowlingSummary.find((u: { player: { id: any; }; }) => u.player.id === this.currentPlayState.selectedBowler1.player.id)]
                this.currentPlayState.selectedBowler2data = [{}]
                Object.assign(this.currentPlayState.selectedBowler1data[0], { dismissalAmount: this.currentPlayState.selectedBowler1data[0].dismissals.length })
            }

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.currentPlayState.selectedBatt1data = [this.inningsData[this.currentPlayState.inningsIndex].battingSummary.find((u: { player: { id: any; }; }) => u.player.id === this.currentPlayState.selectedBatt1.player.id)]
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.currentPlayState.selectedBatt2data = [this.inningsData[this.currentPlayState.inningsIndex].battingSummary.find((u: { player: { id: any; }; }) => u.player.id === this.currentPlayState.selectedBatt2.player.id)]
            this.currentPlayState.selectedBatt1data[0].strikeRate = Math.round((this.currentPlayState.selectedBatt1data[0].strikeRate + Number.EPSILON) * 100) / 100
            // console.log(this.currentPlayState.selectedBatt1data[0].strikeRate)
            this.currentPlayState.selectedBatt2data[0].strikeRate = Math.round((this.currentPlayState.selectedBatt2data[0].strikeRate + Number.EPSILON) * 100) / 100
            this.currentPlayState.isblurred = false
        },

        async foundMatchSetup(matchStatus: any) {
            // console.log(matchStatus)
            if (this.inningsData.length <= 0) {
                this.bowlingTeam = this.MatchInfo.team2
                this.battingTeam = this.MatchInfo.team1
                return
            } else {
                this.currentPlayState.inningsIndex = this.inningsData.length - 1
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                if (this.MatchInfo.team2.team.id == this.inningsData[this.inningsData.length - 1].bowlingTeam.id) {
                    this.bowlingTeam = this.MatchInfo.team2
                    this.battingTeam = this.MatchInfo.team1
                }
                else {
                    this.bowlingTeam = this.MatchInfo.team1
                    this.battingTeam = this.MatchInfo.team2
                }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                if (this.inningsData[this.inningsData.length - 1].previousDeliveries.length > 0 && this.inningsData[this.inningsData.length - 1].nextDelivery == undefined) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    this.currentPlayState.delivery = this.inningsData[this.inningsData.length - 1].lastDelivery
                    this.setbattBowlData()
                }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment 
                // @ts-ignore
                else if (this.inningsData[this.inningsData.length - 1].nextDelivery) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    this.currentPlayState.delivery = this.inningsData[this.inningsData.length - 1].nextDelivery
                    this.setbattBowlData()
                }
                else {
                    this.currentPlayState.delivery.ball = 1
                    this.currentPlayState.delivery.number = 1
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    this.currentPlayState.delivery.innings = this.inningsData[this.inningsData.length - 1].number
                    this.currentPlayState.delivery.over = 0
                    this.currentPlayState.selectedBatt1data = [{}]
                    this.currentPlayState.selectedBatt2data = [{}]
                    this.currentPlayState.selectedBowler2data = [{}]
                }
            }
        },

        async declareInnings(params: any) {
            try {
                await axiosInstance().put(`/match/${this.MatchInfo.id}/declare-innings`, params, { headers: { 'If-Match': 'W/"' + (this.version) + '"' } }).then((response) => {
                    this.apiPostResponse(response)// undefined
                });
            } catch (error) {
                return handleError(error);
            }
        },
        async runSendToIOT(params: any) {
            try {
                await axiosInstance().post(`/match/${this.MatchInfo.id}/ticker`, params).then((response) => {
                    this.apiPostResponse(response)// undefined
                });
            } catch (error) {
                return handleError(error);
            }
        },
        async setMatchStatus(params: any) {
            try {
                await axiosInstance().post(`/match/${this.MatchInfo.id}/set-match-status`, params, { headers: { 'If-Match': 'W/"' + (this.version) + '"' } }).then((response) => {
                    this.apiPostResponse(response)// undefined
                });
            } catch (error) {
                return handleError(error);
            }
        },
        async adjustTargets(params: any, editMode: boolean) {
            try {
                await axiosInstance().put(`/match/${this.MatchInfo.id}/adjust-targets`, params, { headers: { 'If-Match': 'W/"' + (this.version) + '"' } }).then((response) => {
                    this.apiPostResponse(response)// undefined
                });
                if (!editMode) this.getMatchById(this.MatchInfo.id)
            } catch (error) {
                return handleError(error);
            }
        },
        async retreveMatchStatus(matchId: string) {
            try {
                const result: any = await axiosInstance().get(`/match/${matchId}/status`)
                if (result.name == 'AxiosError') {
                    return result.response
                }
                //console.log(result.response.status)
                // this.inningsData = result.innings
                // this.MatchInfo.id = result.id
                return result;
            } catch (error) {
                console.log(error)
                return handleError(error);
            }
        },
    },
})